<template>
    <!--<sliderBar></sliderBar>-->
    <div class="container_homePage" style="overflow-x: hidden;">
        <div class="sliderBar">
            <!-- <carousel-bar></carousel-bar> -->
            <!-- 广告位 -->
            <div class="advertising_banner">
                <!-- <img src="../../assets/index/banner.png" class="" alt=""> -->
                <swiper-bar></swiper-bar>
                <div class="advertising_data">
                    <Row>
                        <!-- <Col :xs="{ span: 24}" :sm="{ span: 6}" :md="{ span: 6}" :lg="{ span: 6 }">
              <div class="font_b">888,888</div>
              <div>定制保险方案</div>
            </Col>-->
                        <Col :xs="{ span: 8 }" :sm="{ span: 8}" :md="{ span: 8}" :lg="{ span: 8 }">
                        <div class="font_b">4000+</div>
                        <div>企业客户</div>
                        </Col>
                        <Col :xs="{ span: 8 }" :sm="{ span: 8}" :md="{ span: 8}" :lg="{ span: 8 }">
                        <div class="font_b">200,000+</div>
                        <div>个人客户</div>
                        </Col>
                        <Col :xs="{ span: 8 }" :sm="{ span: 8}" :md="{ span: 8}" :lg="{ span: 8 }">
                        <div class="font_b">10,000+</div>
                        <div>代理人</div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <!-- 标题 -->
        <div class="title_wrap">
            <Row type="flex" justify="center" align="middle">

                <Col :xs="{ span: 8}" :sm="{ span: 8}" :md="{ span: 8}" :lg="{ span: 8 }">
                </Col>
                <Col :xs="{ span: 8}" :sm="{ span: 8}" :md="{ span: 8}" :lg="{ span: 8 }">为什么选择嘉信保险？</Col>
                <Col :xs="{ span: 8}" :sm="{ span: 8}" :md="{ span: 8}" :lg="{ span: 8 }">
                </Col>
            </Row>
        </div>
        <!-- 标题end  -->
        <div class="why">
            <!-- 5图标 -->
            <div class="list clum5">
                <!-- <div span="4" v-for="(item,key) in iconList" :id="key+1" class="list-item">
          <div
            class="icon"
            :style="{background:'url('+item.icon+') no-repeat',backgroundSize:'cover'}"
          ></div>
          <div class="epitome">{{item.epitome}}</div>
          <div class="descript">{{item.descript}}</div>
        </div>-->

                <Row>
                    <Col v-for="(item,key) in iconList" :key="item" :id="key" :xs="{ span: key==2?24:12}"
                        :lg="{ span: 5, offset: key>0?1:0 }" class="list-item"
                        :justify='key==2?"center":key==0||key==3?"start":"end"'>
                    <!-- :justify="{key==0||key==3?'start':key==1||key==4?'start':'center'}" -->
                    <div class="icon" :style="{background:'url('+item.icon+') no-repeat',backgroundSize:'cover'}"></div>
                    <div class="epitome">{{item.epitome}}</div>
                    <div class="descript">{{item.descript}}</div>
                    </Col>
                </Row>
            </div>
        </div>

        <!-- 横屏图 -->
        <div class="IT_wrap">
            <div class="IT_title">保险科技赋能行业革新 重塑保险行业价值链</div>
            <img src="../../assets/index/IT.png" class="banner_img" alt>
            <img src="../../assets/index/it_icon2.png" class="it_icon_img" alt>
            <div class="It_content">
                <div>
                    <p>已上线功能</p>
                    <ul>
                        <li>闪电上号,团队管理,展业无后顾之忧</li>
                        <li>佣金明细,有迹可查,让你省时省力,专注于出单</li>
                        <li>在线投保,便捷高效,无纸化办公室</li>
                        <li>多产品组合计划书,利益演示表更清晰直观</li>
                        <li>热销产品、宣传海报、热门咨询、产品条款、体检规则一览无余</li>
                    </ul>
                </div>
                <p>功能上线中</p>
                <ul>
                    <li>保单托管,让责任更清晰,保障更合理</li>
                    <li>线上培训,碎片化学习,提升专业技能</li>
                    <li>产品对比,一键对比,产品形态一目了然</li>
                    <li>客户分析报告,多维度交叉分析描绘用户画像</li>
                </ul>
            </div>
        </div>

        <!-- 新闻 -->
        <div class="container5 new_wrap content_w">
            <h1>相关新闻</h1>

            <!-- 轮播 -->
            <div class="swiper-container swiper-container1 swiper-container-initialized swiper-container-horizontal">
                <div class="swiper-wrapper" style="transition-duration: 0ms; transform: translate3d(650px, 0px, 0px);">
                    <div class="swiper-slide swiper-slide-active" v-for="item in newsData " :key="item.id">
                        <img :src="item.img" alt @click="goDetail(item.id)">
                        <div class="detail_wrap" @click="goDetail(item.id)">
                            <h2>{{item.title}}</h2>
                            <p style="    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;">{{item.content}}</p>
                            <span class="detail_btn" @click="goDetail(item.id)">查看全文</span>
                        </div>
                    </div>
                </div>
                <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
            <!-- 轮播 -->
        </div>

        <!-- 底部 -->
        <!-- <div class="bottom_wrap">
      <img class="img_banner" src="../../assets/index/bottom.png" alt="">
      <div class="content_text">
        <Row class="list0">
          <Col  span="20"  offset="4">
            <h2>联系我们</h2>
          </Col>
        </Row>
        <Row class="list1">
          <Col span="5"  offset="4" class="list_l" :xs="12" :sm="5">
            <ul>
              <li>财富热线：020-85656490</li>
              <li>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：hr@jia-xin.cn</li>
              <li>
                 公司地址：广州市天河区兴民路222号之三<br>
                 <span>805室（部位：A）</span> 
              </li>
            </ul>
          </Col>
          <Col span="3" class="list_r" :xs="12" :sm="3">
            <ul>
              <li>公司简介</li>
              <li>相关案例</li>
              <li>招贤纳士</li>
              <li>公开信息披露</li>
            </ul>
          </Col>
        </Row>
        <Row class="list2">
          <Col span="24">
          <div class="b_text1">合作网站：广东中嘉正医精细健康管理有限公司</div>
          <div class="b_text2">CopyRight © 2018 嘉信保险经纪有限公司 版权所有 粤ICP备18102183号-1</div>
          </Col>
        </Row>
      </div>
    </div>-->
        <!-- 底部end -->
    </div>
</template>


<script>
import benefitIcon from "../../assets/benefit.png";
import resourceIcon from "../../assets/resource.png";
import connectionIcon from "../../assets/connection.png";

import icon1 from "../../assets/index/icon1.png";
import icon2 from "../../assets/index/icon2.png";
import icon3 from "../../assets/index/icon3.png";
import icon4 from "../../assets/index/icon4.png";
import icon5 from "../../assets/index/icon5.png";

import newImg0 from "../../assets/news_00.png";
import newImg1 from "../../assets/new_01.jpg";
import newImg2 from "../../assets/new_02.jpg";
import newImg3 from "../../assets/new_03.jpg";
var whySource = [
    {
        key: "benefit",
        icon: benefitIcon,
        epitome: "超高收益",
        descript:
            "嘉信保险推广费比例高达50%，部分产品可达100%，远超行业内其他产品推广费比例。"
    },
    {
        key: "connection",
        icon: connectionIcon,
        epitome: "群英荟萃",
        descript:
            "企业长达十几年的经营历史为您的签单保驾护航，多位国内一流保险师与您一起并肩作战"
    },
    {
        key: "resource",
        icon: resourceIcon,
        epitome: "产品优势",
        descript:
            "与多家保险公司强强联手，产品选择多，皆为极具竞争力的明星爆款。"
    }
];
var iconList = [
    {
        key: "icon1",
        icon: icon1,
        epitome: "权威认证",
        descript: "银保监会  认证批复"
    },
    {
        key: "icon2",
        icon: icon2,
        epitome: "深耕行业",
        descript: "扎根保险经纪十余载"
    },
    {
        key: "icon4",
        icon: icon4,
        epitome: "精英荟萃",
        descript: "一流保险师为您保驾护航"
    },
    {
        key: "icon5",
        icon: icon5,
        epitome: "产品优势",
        descript: "产品选择多  竞争力强"
    }
];
var newsSource = [
    {
        id: 0,
        img: newImg0,
        title: "嘉信保险经纪山东平阴分公司9.12开业庆典",
        content:
            "“时维九月，序属三秋”，在这样一个充满收获和希望的季节里，嘉信保险经纪山东平阴分公司的家人们怀着无比激动，无比自豪的心情共同见证了这一重要的历史时刻...",
        dateTime: "2018-09-12"
    },
    {
        id: 1,
        img: newImg1,
        title: "车险费改再陷怪圈 肉都被渠道吃了...",
        content:
            "4月中下旬，多份涉及车险费率市场化改革的文件已下发至保险公司，而在前期两批共18个地区试点之后，商业车险费率改革有望全国铺开。去年6月1日起",
        dateTime: "2018-09-01"
    },
    {
        id: 2,
        img: newImg2,
        title: "乡村振兴战略下农村保险市场前景...",
        content:
            " 近日，中共中央政治局召开会议，审议《乡村振兴战略规划(2018-2022年)》和《关于打赢脱贫攻坚战三年行动的指导意见》。会议指出",
        dateTime: "2018-09-01"
    },
    {
        id: 3,
        img: newImg3,
        title: "以税延优惠政策为契机 全面构建...",
        content:
            "近日,银保监会等部门发布《个人税收递延型商业养老保险产品开发指引》,明确税延型养老险的设计原则、交费方式、收益",
        dateTime: "2018-09-01"
    }
];
import carouselBar from "../../components/Banner";
import SwiperBar from "../../components/swipter";
import Swiper from "swiper";
export default {
    components: { carouselBar, SwiperBar },
    name: "homePage",
    data() {
        return {
            whyData: whySource,
            iconList: iconList,
            newsData: newsSource
        };
    },
    methods: {
        goDetail: function(id) {
            this.$router.push({
                path: "/newDetail",
                query: { id: id, type: "news" }
            });
        }
    },
    mounted() {
        var swiper = new Swiper(".swiper-container1", {
            slidesPerView: 3,
            loop: true,
            initialSlide: 2,
            spaceBetween: 0,
            autoHeight: true,
            centeredSlides: true,
            // autoplay: {
            //   disableOnInteraction: false
            // },
            runCallbacksOnInit: false
        });
    }
};
</script>
<style scoped lang="less" src="../../style/index.less"></style>
<style scoped lang="less" src="../../style/rem.css"></style>
<style scoped lang="less" src="./index.less">
</style>



// WEBPACK FOOTER //
// src/page/HomePage/index.vue